<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>

        <div class="category-list">
          <h2>Vulnerabilities</h2>
          <p class="not-available" style="color: #8e8e8e; margin-top: 15px">
            <i>vulnerability details</i>
          </p>
        </div>
      </div>
      <div class="col-md-8 col-lg-8 col-xl-8">
        <div class="content">
          <div class="content new-item">
            <h2 class="block-title" style="margin-bottom: 30px" v-if="isNew">New vulnerability</h2>
            <h2 class="block-title" style="margin-bottom: 30px" v-else>{{ form.name }}</h2>
            <el-form ref="vulnform" label-position="top" :model="form" @submit.native.prevent>
              <el-form-item prop="name" label="Name" :rules="[
                {
                  required: true,
                  message: 'Please input vulnerability name',
                  trigger: 'blur',
                },
              ]">
                <input name="name" type="text" v-model="form.name" class="form-control"
                  placeholder='For example: RCE in Grafana image renderer or CVE-2026-1042' />
              </el-form-item>

              <el-form-item label="Description">
                <el-input v-model="form.description" type="textarea" :rows="5"
                  placeholder="Description"></el-input>
              </el-form-item>

              <el-form-item label="Severity">
                <el-select v-model="form.severity" placeholder="Select severity" style="width: 200px">
                  <el-option label="Info" value="info"></el-option>
                  <el-option label="Low" value="low"></el-option>
                  <el-option label="Medium" value="medium"></el-option>
                  <el-option label="High" value="high"></el-option>
                  <el-option label="Critical" value="critical"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="CVSS (optional)">
                <el-input-number v-model="form.cvss" :min="0" :max="10" :precision="1" :step="0.1"
                  controls-position="right"></el-input-number>
                <button type="button" class="btn btn-sm btn-icon" style="margin-left: 8px"
                  v-if="form.cvss != null" @click="form.cvss = null" title="Clear CVSS">
                  <i class="vik vik-delete"></i>
                </button>
              </el-form-item>

              <el-form-item label="Tags">
                <el-select v-model="form.tags" multiple filterable allow-create default-first-option
                  placeholder="CVE-2026-1042, CWE-79, ...">
                </el-select>
              </el-form-item>

              <el-form-item label="Links">
                <div class="links-section">
                  <div v-for="(link, index) in links" :key="index" class="link-item">
                    <input type="text" v-model="links[index]" class="form-control"
                      placeholder="https://..." />
                    <button type="button" class="btn btn-sm btn-icon del" @click="removeLink(index)">
                      <i class="vik vik-delete"></i>
                    </button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="addLink">
                    <i class="vik vik-plus"></i>Add link
                  </button>
                </div>
              </el-form-item>

              <el-form-item label="Translations">
                <div class="translations-section">
                  <div v-for="(translation, index) in translations" :key="index" class="translation-item">
                    <div class="translation-header">
                      <el-select v-model="translation.lang" filterable placeholder="Select language"
                        style="width: 200px; margin-right: 10px;">
                        <el-option label="English" value="en"></el-option>
                        <el-option label="Russian" value="ru"></el-option>
                        <el-option label="Spanish" value="es"></el-option>
                        <el-option label="French" value="fr"></el-option>
                        <el-option label="German" value="de"></el-option>
                        <el-option label="Chinese" value="zh"></el-option>
                        <el-option label="Japanese" value="ja"></el-option>
                        <el-option label="Korean" value="ko"></el-option>
                      </el-select>
                      <button type="button" class="btn btn-sm btn-icon del" @click="removeTranslation(index)">
                        <i class="vik vik-delete"></i>
                      </button>
                    </div>
                    <div v-if="translation.lang" class="translation-fields">
                      <el-form-item label="Name">
                        <input type="text" v-model="translation.name" class="form-control"
                          :placeholder="'Translated name for ' + translation.lang" />
                      </el-form-item>
                      <el-form-item label="Description">
                        <el-input v-model="translation.description" type="textarea" :rows="3"
                          :placeholder="'Translated description for ' + translation.lang"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <button type="button" class="btn btn-primary" @click="addTranslation">
                    <i class="vik vik-plus"></i>Add Translation
                  </button>
                </div>
              </el-form-item>
            </el-form>

            <div class="form-group">
              <div class="btn-line">
                <button type="button" class="btn btn-success" @click="save">
                  <i class="vik vik-save"></i>Save
                </button>
                <button type="button" class="btn btn-danger" v-if="!isNew" @click="remove">
                  <i class="vik vik-delete"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as utils from "@/utils.js";
import { getVulnerability } from "@/api.js";

export default {
  data() {
    return {
      isNew: false,
      form: {
        vulnerability_id: "",
        name: "",
        description: "",
        cvss: null,
        severity: "medium",
        tags: [],
        links: null,
        translations: null,
      },
      links: [],
      translations: [],
    };
  },
  mounted() {
    if (this.$route.params.id == "new") {
      this.isNew = true;
    }
    if (!this.isNew) {
      this.load();
    }
  },
  methods: {
    async load() {
      getVulnerability(this.$route.params.id).then((data) => {
        if (data.status === "error") {
          utils.showError(this, "Error", data.error);
          return;
        }
        const d = data.Data;
        this.form.vulnerability_id = d.vulnerability_id;
        this.form.name = d.name;
        this.form.description = d.description;
        this.form.cvss = d.cvss != null ? d.cvss : null;
        this.form.severity = d.severity || "medium";

        this.form.tags = [];
        if (d.tags) {
          try {
            let tagsArr = typeof d.tags === "string" ? JSON.parse(d.tags) : d.tags;
            if (Array.isArray(tagsArr)) {
              this.form.tags = tagsArr;
            }
          } catch (e) {
            console.error("Error parsing tags:", e);
          }
        }

        this.links = [];
        if (d.links) {
          try {
            let linksArr = typeof d.links === "string" ? JSON.parse(d.links) : d.links;
            if (Array.isArray(linksArr)) {
              this.links = linksArr;
            }
          } catch (e) {
            console.error("Error parsing links:", e);
          }
        }

        this.translations = [];
        if (d.translations) {
          try {
            let translationsObj =
              typeof d.translations === "string"
                ? JSON.parse(d.translations)
                : d.translations;
            for (const [lang, trans] of Object.entries(translationsObj)) {
              this.translations.push({
                lang: lang,
                name: trans.name || "",
                description: trans.description || "",
              });
            }
          } catch (e) {
            console.error("Error parsing translations:", e);
          }
        }
      });
    },
    addLink() {
      this.links.push("");
    },
    removeLink(index) {
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },
    addTranslation() {
      this.translations.push({
        lang: "",
        name: "",
        description: "",
      });
    },
    removeTranslation(index) {
      if (index > -1) {
        this.translations.splice(index, 1);
      }
    },
    save() {
      let that = this;
      this.$refs["vulnform"].validate((valid) => {
        if (valid) {
          const translationsObj = {};
          this.translations.forEach((trans) => {
            if (trans.lang) {
              translationsObj[trans.lang] = {
                name: trans.name || "",
                description: trans.description || "",
              };
            }
          });
          if (Object.keys(translationsObj).length > 0) {
            this.form.translations = translationsObj;
          } else {
            this.form.translations = null;
          }

          const filteredLinks = this.links.filter((l) => l && l.trim());
          this.form.links = filteredLinks.length > 0 ? filteredLinks : null;

          const payload = Object.assign({}, this.form, {
            tags: this.form.tags && this.form.tags.length > 0 ? this.form.tags : null,
            links: this.form.links,
            translations: this.form.translations,
          });

          utils
            .$post("/api/vulnerabilities/save/", payload)
            .then((data) => {
              that.$router.push({ name: "Vulnerabilities" });
              that.form.vulnerability_id = data.ID;
              that.$notify.success({
                title: "Success",
                message: "Vulnerability saved",
              });
            })
            .catch(function (err) {
              utils.showError(that, "Error", "Failed to save vulnerability\n" + err);
            });
        } else {
          utils.showError(that, "Error", "Please fill required fields");
        }
      });
    },
    remove() {
      let that = this;
      this.$confirm("Delete this vulnerability?", "Warning", {
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          utils
            .$post("/api/vulnerabilities/remove/", { id: that.form.vulnerability_id })
            .then(() => {
              that.$router.push({ name: "Vulnerabilities" });
              that.$notify.success({
                title: "Success",
                message: "Vulnerability deleted",
              });
            })
            .catch(function (err) {
              utils.showError(that, "Error", "Failed to delete\n" + err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.translations-section {
  width: 100%;
}

.translation-item {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.translation-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.translation-fields {
  margin-top: 15px;
}

.translation-fields .el-form-item {
  margin-bottom: 15px;
}

.links-section {
  width: 100%;
}

.link-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
}

.link-item .form-control {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/SingleVulnerability.vue